import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';

export const AddressTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(3)
}));

export const AddressRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  padding: theme.spacing(2),
  position: 'relative',
  backgroundColor: theme.palette.neutrals.beige1,
  borderRadius: '8px',
  minHeight: theme.spacing(10),
  border: `1px solid ${theme.palette.neutrals.beige4}`,
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  marginBottom: theme.spacing(3),
  cursor: 'pointer',
  '&.disabled': {
    cursor: 'not-allowed',
    opacity: 0.5
  }
}));

export const AddressRadio = styled(Radio)(({ theme }) => ({
  top: '-8px',
  '&.Mui-checked': {
    color: theme.palette.neutrals.lead
  }
}));
